export default "__VITE_ASSET__UgfSrUoQ__"